import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "getDataSourceBlueprintLogo", standalone: true })
export class GetDataSourceBlueprintLogoPipe implements PipeTransform {
  public transform(logoUrl: string, dataSourceName: string, ext: "png" | "jpg"): string {
    return logoUrl || (dataSourceName && ext ? `/dist/img/logos/${dataSourceName}.${ext}` : null);
  }
}
